export const DETAIL_PANEL_TAB_DEALER_360 = 'dealer360';
export const DETAIL_PANEL_TAB_SELECTIONS = 0;
export const DETAIL_PANEL_TAB_RAW_JSON = 1;
export const DETAIL_PANEL_TAB_EDIT_AND_SEND = 2;
export const DETAIL_PANEL_TAB_HISTORY = 3;
export const DETAIL_PANEL_TAB_APPSHEET = 4;
export const DETAIL_PANEL_TAB_TRADE = 5;
